import styled, { css } from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledHead = styled.div.attrs({ className: 'head' })`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	width: 100%;
`;

const StyledPriceContainer = styled.div.attrs({ className: 'price' })`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	font-size: 14px;
	color: #ffffff;
	transition: color 0.3s ease;
	margin-top: 2px;
`;

const StyledDisabledContainer = styled.div.attrs({ className: 'disabled' })`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

const StyledCarClassContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 6px;
	background-color: rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;

	${Text} {
		color: #ffffff;
	}
`;

const StyledContainer = styled.div<{
	$disabled?: boolean;
	$selected?: boolean;
}>`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 14px;
	height: 200px;
	padding: 20px;
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);

	& > ${StyledHead} > ${Text} {
		color: #ffffff;
		transition: color 0.3s ease;
	}

	${(props) =>
		props.$disabled
			? css`
					pointer-events: none;

					& *:not(.disabled):not(span) {
						opacity: 0.1;
					}
			  `
			: props.$selected
			? css`
					background-color: #2d70da;

					${StyledHead} > ${StyledCarClassContainer} > ${Text} {
						color: #000000;
					}

					${StyledHead} > ${StyledCarClassContainer} {
						background-color: #ffffff;
					}
			  `
			: css`
					background-color: rgba(255, 255, 255, 0.05);
					transition: background-color 0.3s ease;
					cursor: pointer;

					&:hover {
						background-color: #ffffff;

						${StyledHead} > ${Text} {
							color: #000000;
						}

						${StyledHead} > ${StyledCarClassContainer} {
							background-color: #000000;
						}

						${StyledPriceContainer} > ${Text} {
							color: #000000;
						}
					}
			  `}
`;

const StyledCarName = styled(Text)`
	max-width: 115px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
	font-weight: 500;
`;

export {
	StyledCarClassContainer,
	StyledCarName,
	StyledContainer,
	StyledDisabledContainer,
	StyledHead,
	StyledPriceContainer,
};
